import React, { memo, forwardRef } from "react";
const SvgStrictsuperset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8 23a1 1 0 011-1h7a6 6 0 000-12H9a1 1 0 110-2h7a8 8 0 110 16H9a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgStrictsuperset.displayName = "SvgStrictsuperset";
const MemoForwardRef = memo(SvgStrictsuperset);
export default MemoForwardRef;
